import { appConst } from "../../AppConst";
import { IGenQRRequest } from "../../model/request/ngan-hang/IGenQRRequest";
import { ITraSoatQRRequest } from "../../model/request/ngan-hang/ITraSoatQRRequest";
import { IAccThietLapNganHang } from "../../model/respone/category/IAccThietLapNganHang";
import { apiClient } from "../apiClient";

export const THIET_LAP_NGAN_HANG_ENDPOINT = "thiet-lap-ngan-hang";
export const NGAN_HANG_ENDPOINT = "ngan-hang";
export const nganHangApi = {
  SelectAll: () => apiClient.get(`${THIET_LAP_NGAN_HANG_ENDPOINT}`),
  Insert: (payload: IAccThietLapNganHang) =>
    apiClient.post(`${THIET_LAP_NGAN_HANG_ENDPOINT}`, payload),
  Update: (payload: IAccThietLapNganHang) =>
    apiClient.put(`${THIET_LAP_NGAN_HANG_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${THIET_LAP_NGAN_HANG_ENDPOINT}/${id}`),
  GenQR: (request: IGenQRRequest) =>
    apiClient.post(`${NGAN_HANG_ENDPOINT}/gen-qr`, request),
  GenQRMulti: (request: IGenQRRequest) =>
    apiClient.post(`${NGAN_HANG_ENDPOINT}/gen-qr-multi`, request),
  TraSoatQR: (payload: ITraSoatQRRequest) => {
    if (!payload.code_bank)
      return apiClient.get(
        `${NGAN_HANG_ENDPOINT}/tra-soat/${payload.id_encode_bank}?is_from_tc=${appConst.TRA_SOAT_FROM_API}`,
      );
    else {
      return apiClient.get(
        `${NGAN_HANG_ENDPOINT}/tra-soat/${payload.code_bank}/${payload.id_encode_bank}?is_from_tc=${appConst.TRA_SOAT_FROM_API}`,
      );
    }
  },
  SelectBank: (code_bank: string) =>
    apiClient.get(`${NGAN_HANG_ENDPOINT}/get-banks/${code_bank}`),
};
